module.exports = __webpack_public_path__ + "media/images/homes/things-to-consider-food-app-a65044d585973fefa92db8f847bf1fab.jpg";